import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
export var DropdownItem = function (props) {
    var className = props.className, children = props.children, _a = props.component, Component = _a === void 0 ? 'div' : _a, otherProps = __rest(props, ["className", "children", "component"]);
    return (React.createElement(Component, __assign({ className: cx('dropdown-item', className) }, otherProps), children));
};
//# sourceMappingURL=DropdownItem.js.map